import DottedBackground, { IDottedBackgroundProps } from '@components/layout/DottedBackground/DottedBackground';
import clsx from 'clsx';
import { PropsWithChildren, ReactElement } from 'react';

const CONTAINER_CLASSNAME = 'overflow-auto h-[calc(100%-70px)] md:h-full';
const CHILD_CLASSNAME = 'max-w-[1440px] w-full mx-auto h-full';

interface PublicLayoutContentProps {
    dottedBackgroundProps?: IDottedBackgroundProps;
    containerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
    childContainerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
    extraJSX?: ReactElement;
}

const PublicLayoutContent = ({
    dottedBackgroundProps,
    containerProps,
    childContainerProps,
    children,
    extraJSX,
}: PropsWithChildren<PublicLayoutContentProps>) => {
    return dottedBackgroundProps ? (
        <DottedBackground
            {...dottedBackgroundProps}
            className={clsx(CONTAINER_CLASSNAME, dottedBackgroundProps.className)}
        >
            <div {...childContainerProps} className={clsx(CHILD_CLASSNAME, childContainerProps?.className)}>
                {children}
            </div>
        </DottedBackground>
    ) : (
        <div {...containerProps} className={clsx(CONTAINER_CLASSNAME, containerProps?.className)} id="react-page">
            {extraJSX}
            <div {...childContainerProps} className={clsx(CHILD_CLASSNAME, childContainerProps?.className)}>
                {children}
            </div>
        </div>
    );
};

export { PublicLayoutContent };
